// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".index-page[data-v-2f13b0e7]{display:flex;flex-direction:column}.index-page__categories[data-v-2f13b0e7]{margin-top:41px}.index-page__discounts[data-v-2f13b0e7]{margin-top:115px}@media (max-width:1023px){.index-page__discounts[data-v-2f13b0e7]{margin-top:3px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
